import { ELIG_TOKENS } from '@features/eligibility-checks/theme/readinessTokens';
import { Box, Typography } from '@mui/material';

import type { DisplayState } from '../vocabulary';
import { DISPLAY_STATE_LABELS } from '../vocabulary';

/**
 * Readiness-style tone per state, matching the reviewed round-1 prototype.
 * Hollow dot = something is still owed, filled = settled.
 */
const STATE_TONE: Record<
  DisplayState,
  { color: string; bg: string; filled: boolean }
> = {
  missing: { color: ELIG_TOKENS.red, bg: ELIG_TOKENS.redTint, filled: false },
  requested: { color: ELIG_TOKENS.amber, bg: ELIG_TOKENS.amberTint, filled: false },
  received: { color: ELIG_TOKENS.green, bg: ELIG_TOKENS.greenTint, filled: true },
  waived: { color: ELIG_TOKENS.gray, bg: ELIG_TOKENS.grayTint, filled: true },
  cancelled: { color: ELIG_TOKENS.gray, bg: ELIG_TOKENS.grayTint, filled: true },
};

export const RequirementStateChip = ({ state }: { state: DisplayState }) => {
  const tone = STATE_TONE[state];

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1,
        py: 0.25,
        borderRadius: '999px',
        backgroundColor: tone.bg,
      }}
    >
      <Box
        component="span"
        aria-hidden
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          flexShrink: 0,
          backgroundColor: tone.filled ? tone.color : 'transparent',
          border: `2px solid ${tone.color}`,
          boxSizing: 'border-box',
        }}
      />
      <Typography component="span" sx={{ fontSize: 12, fontWeight: 650, color: tone.color }}>
        {DISPLAY_STATE_LABELS[state]}
      </Typography>
    </Box>
  );
};
